export const headers = [
    {
        text: 'Tarefa',
        align: 'start',
        sortable: true,
        value: 'taskType',
        width: '10%'
    },
    {
        text: 'Cliente',
        align: 'start',
        sortable: true,
        value: 'clientName',
        width: '10%'
    },
    {
        text: 'Data de criação',
        align: 'start',
        sortable: true,
        value: 'createdDate',
        width: '10%'
    },
    {
        text: 'Início',
        align: 'start',
        sortable: true,
        value: 'startDate',
        width: '10%'
    },
    {
        text: 'Final',
        align: 'start',
        sortable: true,
        value: 'endDate',
        width: '10%'
    },
    {
        text: 'Placa',
        align: 'start',
        sortable: true,
        value: 'plate',
        width: '10%'
    },
    {
        text: 'Status',
        align: 'start',
        sortable: true,
        value: 'status',
        width: '10%'
    },
    {
        text: 'Técnico Responsável',
        align: 'start',
        sortable: true,
        value: 'technicianName',
        width: '15%'
    },
    {
        text: 'Ativo',
        align: 'start',
        sortable: true,
        value: 'active',
        width: '5%'
    },
    {
        text: 'Ações',
        align: 'right',
        sortable: true,
        value: 'actions',
        width: '5%'
    },
]